// extracted by mini-css-extract-plugin
export var banner = "_2r-0";
export var icon = "_2r-1";
export var message = "_2r-2";